import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, Input } from '@angular/core';
import { NgDocFocusableDirective } from '@ng-doc/ui-kit/directives/focusable';
import { NgDocFocusUtils } from '@ng-doc/ui-kit/utils';
const _c0 = ["*"];
let NgDocFocusControlComponent = /*#__PURE__*/(() => {
  class NgDocFocusControlComponent {
    constructor(documentRef) {
      this.documentRef = documentRef;
      this.focusHost = null;
    }
    focusPrev() {
      if (this.focusHost) {
        NgDocFocusUtils.focusClosestElement(this.focusHost, this.documentRef.body, false);
      }
    }
    focusNext() {
      if (this.focusHost) {
        NgDocFocusUtils.focusClosestElement(this.focusHost, this.documentRef.body);
      }
    }
    static {
      this.ɵfac = function NgDocFocusControlComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocFocusControlComponent)(i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocFocusControlComponent,
        selectors: [["ng-doc-focus-control"]],
        inputs: {
          focusHost: "focusHost"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [["data-ng-doc-focus-trap", "true", 3, "focus", "ngDocFocusable"]],
        template: function NgDocFocusControlComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("focus", function NgDocFocusControlComponent_Template_div_focus_0_listener() {
              return ctx.focusPrev();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(1);
            i0.ɵɵelementStart(2, "div", 0);
            i0.ɵɵlistener("focus", function NgDocFocusControlComponent_Template_div_focus_2_listener() {
              return ctx.focusNext();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngDocFocusable", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngDocFocusable", true);
          }
        },
        dependencies: [NgDocFocusableDirective],
        styles: ["[_nghost-%COMP%]{width:100%}"],
        changeDetection: 0
      });
    }
  }
  return NgDocFocusControlComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocFocusControlComponent };
